import axios from "axios";
import HoldOn from "react-hold-on";
import toast from "react-hot-toast";
import {
  docError,
  panSuccess,
  passportFrontSuccessStudent,
  passportBackSuccessStudent,
  passportFrontSuccessRemitters,
  passportBackSuccessRemitters,
  aadhaarFrontSuccessStudent,
  aadhaarBackSuccessStudent,
  aadhaarFrontSuccessRemitters,
  aadhaarBackSuccessRemitters,
  panDocSuccess,
  passportDocFrontSuccessStudent,
  passportDocBackSuccessStudent,
  passportDocFrontSuccessRemitters,
  passportDocBackSuccessRemitters,
  aadhaarDocFrontSuccessStudent,
  aadhaarDocBackSuccessStudent,
  aadhaarDocFrontSuccessRemitters,
  aadhaarDocBackSuccessRemitters,
  offerLetterSuccessStudent,
  docLoading,
} from "../../Reducer/docReducer";
import { generateRandomNumber } from "../../../utils/RandomNoGen";
import apiUrl from "../../ApiUrl";

const uploadFileAPI = async (file, id, fileType, dispatch, successAction,uid) => {
  const options = {
    theme: 'sk-cube-grid',
    message: "Uploading File...",
  };

  if (!file || !file.name) {
    console.error("No valid file provided for upload.");
    dispatch(docError("No valid file provided for upload."));
    return;
  }

  try {
    HoldOn.open(options);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("uid", uid);
    formData.append("file_key", fileType);


    const response = await axios.post(`${apiUrl}file/process`, formData);

    if (response.data && response.data.uploadResponse && response.data.uploadResponse?.object_url) {
      dispatch(successAction({ 
        object_url: response.data.uploadResponse.object_url, 
        path: response.data.uploadResponse.key 
      }));
      toast.success("File uploaded successfully");
    } else {
      throw new Error("Unexpected response from the server");
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    dispatch(docError("Error uploading file"));
  } finally {
    HoldOn.close();
  }
};

export const uploadFile = (file, docType,id) => async (dispatch) => {
  console.log(`Starting upload for document type: ${docType}`);

  if (!file || !file.name) {
    console.error("Invalid file object.");
    dispatch(docError("Invalid file object."));
    return;
  }

  switch (docType) {
    case "pan":
    case "remitters_pan":
      await uploadFileAPI(file, id, "pan", dispatch, panSuccess,id);
      await dispatch(panDocSuccess(file));
      break;
    case "self_passport front":
      await uploadFileAPI(file, id,
        // "ppf_r",
        "ppfself_r",
        dispatch,
        passportFrontSuccessRemitters,
        id
      );
      await dispatch(passportDocFrontSuccessRemitters(file));
      break;

    case "self_passport back":
      await uploadFileAPI(
        file,
        id,
        // "ppb_r",
        "ppbself_r",
        dispatch,
        passportBackSuccessRemitters,
        id
      );
      await dispatch(passportDocBackSuccessRemitters(file));
      break;
    case "student_passport front":
      await uploadFileAPI(
        file,
        id,
        "ppf_s",
        dispatch,
        passportFrontSuccessStudent,
        id
      );
      await dispatch(passportDocFrontSuccessStudent(file));
      break;
    case "student_passport back":
      await uploadFileAPI(
        file,
        id,
        "ppb_s",
        dispatch,
        passportBackSuccessStudent,
        id
      );
      await dispatch(passportDocBackSuccessStudent(file));
      break;
    case "remitters_aadhaar front":
      await uploadFileAPI(
        file,
        id,
        "af_r",
        dispatch,
        aadhaarFrontSuccessRemitters,
        id
      );
      await dispatch(aadhaarDocFrontSuccessRemitters(file));
      break;
    case "student_aadhaar_front":
      await uploadFileAPI(
        file,
        id,
        "af_s",
        dispatch,
        aadhaarFrontSuccessStudent,
        id
      );
      await dispatch(aadhaarDocFrontSuccessStudent(file));
      break;
    case "student_aadhaar_back":
      await uploadFileAPI(
        file,
        id,
        "ab_s",
        dispatch,
        aadhaarBackSuccessStudent,
        id
      );
      await dispatch(aadhaarDocBackSuccessStudent(file));
      break;
    case "remitters_aadhaar back":
      await uploadFileAPI(
        file,
        id,
        "ab_r",
        dispatch,
        aadhaarBackSuccessRemitters,
        id
      );
      await dispatch(aadhaarDocBackSuccessRemitters(file));
      break;
    default:
      console.error("Unsupported document type");
      dispatch(docError("Unsupported document type"));
      break;
  }
};

export const uploadOfferLetter = (file) => async (dispatch) => {
  try {
    dispatch(docLoading());
    
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(
      `${apiUrl}file/upload`, 
      formData,
      {
        headers: {
          "file-type": "offer_letter",
          "Content-Type": "multipart/form-data"
        }
      }
    );

    console.log("Offer letter response:", response.data);

    // Check if response exists and has object_url directly
    if (response?.data && response.data.object_url) {
      await dispatch(offerLetterSuccessStudent(response.data.object_url));
    } else {
      console.error("Invalid response:", response.data);
      throw new Error("Invalid response from server");
    }

  } catch (error) {
    console.error("Error uploading offer letter:", error);
    dispatch(docError(error?.response?.data?.message || "Failed to upload offer letter"));
  }
};
